/*
 * Cart drawer discount progress bar.
 *
 * The target is $75 in the SHOP currency. Shopify's automatic discount
 * ("15% off entire order - Minimum purchase of $75.00") is defined in shop
 * currency too, so we convert the target into whatever currency the customer is
 * being shown, using Shopify.currency.rate. That keeps the bar honest in USD,
 * DKK, EUR or anything else Markets serves.
 *
 * Dawn re-renders the whole drawer from the server on every cart change, so the
 * markup (and its data-cart-total) is replaced each time. A debounced
 * MutationObserver re-runs the calculation after each re-render, which means the
 * bar follows add / quantity / remove without any page reload and without
 * depending on Dawn's internal pub-sub.
 */

if (!window.__afCartProgressBound) {
  window.__afCartProgressBound = true;

  var COMPLETE_CLASS = 'af-progress--complete';
  var celebrated = false;
  var updating = false;

  var currencyRate = function () {
    var rate = window.Shopify && window.Shopify.currency && window.Shopify.currency.rate;
    var parsed = parseFloat(rate);
    return isFinite(parsed) && parsed > 0 ? parsed : 1;
  };

  /*
   * Derive the store's own money formatting from a sample that Liquid rendered
   * through the `money` filter (1111.11 in the presentment currency). This makes the
   * progress amount match the prices shown directly below it - "256,07 kr" in DKK,
   * "$256.07" in USD - instead of Intl's locale guess.
   */
  var parseFormat = function (sample) {
    if (!sample) return null;
    var match = sample.match(/[\d][\d.,\s ']*\d|\d/);
    if (!match) return null;
    var digits = match[0];
    var format = {
      prefix: sample.slice(0, match.index),
      suffix: sample.slice(match.index + digits.length),
      group: '',
      decimal: '',
    };
    // The separator followed by exactly two trailing digits is the decimal one.
    var dec = digits.match(/([.,])(\d{2})$/);
    if (dec) {
      format.decimal = dec[1];
      var rest = digits.slice(0, digits.length - 3);
      var grp = rest.match(/([.,\s '])/);
      format.group = grp ? grp[1] : '';
    }
    return format;
  };

  var formatMoney = function (cents, isoCode, sample) {
    var amount = cents / 100;
    var format = parseFormat(sample);

    if (format && format.decimal) {
      var parts = amount.toFixed(2).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, format.group);
      return format.prefix + whole + format.decimal + parts[1] + format.suffix;
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: isoCode,
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + (isoCode || '');
    }
  };

  var update = function (root) {
    var cartTotal = parseInt(root.dataset.cartTotal, 10);
    var targetShop = parseInt(root.dataset.targetShopCents, 10);
    if (!isFinite(cartTotal) || !isFinite(targetShop) || targetShop <= 0) return;

    // Convert the shop-currency target into the customer's presentment currency.
    var target = targetShop * currencyRate();
    var remaining = Math.max(0, target - cartTotal);
    var percent = Math.min(100, Math.max(0, (cartTotal / target) * 100));
    var complete = remaining <= 0;

    var textEl = root.querySelector('[data-af-progress-text]');
    var fillEl = root.querySelector('[data-af-progress-fill]');

    if (textEl) {
      var next = complete
        ? 'Congratulations! You have reached a 15% discount'
        : 'You are ' + formatMoney(remaining, root.dataset.currency, root.dataset.moneySample) + ' away from a 15% discount';
      if (textEl.textContent !== next) textEl.textContent = next;
    }

    if (fillEl) {
      var width = percent.toFixed(2) + '%';
      if (fillEl.style.width !== width) fillEl.style.width = width;
    }

    root.classList.toggle(COMPLETE_CLASS, complete);

    // Celebrate only on the transition into "reached", not on every re-render.
    if (complete && !celebrated) {
      celebrated = true;
      burst(root);
    } else if (!complete) {
      celebrated = false;
    }
  };

  /* Tiny CSS-only confetti: a handful of spans that remove themselves. */
  var burst = function (root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var layer = document.createElement('span');
    layer.className = 'af-progress__confetti';
    for (var i = 0; i < 12; i++) {
      var bit = document.createElement('i');
      bit.style.setProperty('--x', (Math.random() * 100).toFixed(1) + '%');
      bit.style.setProperty('--d', (0.5 + Math.random() * 0.5).toFixed(2) + 's');
      bit.style.setProperty('--r', Math.round(Math.random() * 360) + 'deg');
      layer.appendChild(bit);
    }
    root.appendChild(layer);
    setTimeout(function () {
      if (layer.parentNode) layer.parentNode.removeChild(layer);
    }, 1400);
  };

  var updateAll = function () {
    if (updating) return;
    updating = true;
    document.querySelectorAll('[data-af-progress]').forEach(update);
    updating = false;
  };

  var timer = null;
  var schedule = function () {
    clearTimeout(timer);
    timer = setTimeout(updateAll, 50);
  };

  var observe = function () {
    updateAll();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.afProgressObserved === 'true') return;
    drawer.dataset.afProgressObserved = 'true';
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
  document.addEventListener('shopify:section:load', observe);
}
